import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject12(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Tiendas de campaña");
    await safeDeleteSheet(context, "Pesca");

    // ─── SHEET 1: Tiendas de campaña ───
    const sheet1 = context.workbook.worksheets.add("Tiendas de campaña");

    // Title (merged A1:E1)
    sheet1.getRange("A1").values = [
      ["Ventas de campamento - Tiendas de campañas"],
    ];
    sheet1.getRange("A1:E1").merge();
    sheet1.getRange("A1").format.font.name = "Cambria";
    sheet1.getRange("A1").format.font.size = 28;
    sheet1.getRange("A1").format.font.color = "#375623";
    sheet1.getRange("A1").format.font.bold = false;
    sheet1.getRange("A1").format.horizontalAlignment = "Left";
    sheet1.getRange("A1").format.verticalAlignment = "Center";
    sheet1.getRange("1:1").format.rowHeight = 50;

    // Table
    const headers1 = [
      "Artículo #",
      "Descripción",
      "Inventario",
      "Precio",
      "Total",
    ];

    const data1: (string | number)[][] = [
      [4001, "Tienda para 1 persona", 8, 99.5, 796.0],
      [4002, "Tienda para 2 personas", 16, 134.5, 2152.0],
      [4003, "Tienda para 4 personas", 10, 179.0, 1790.0],
      [4004, "Tienda gigante para cama de camión", 3, 599.0, 1797.0],
      [6001, "Tienda con combo de  nevera para 1 persona", 2, 179.0, 358.0],
      [6002, "Tienda con combo de  nevera para 2 personas", 3, 209.0, 627.0],
      [6003, "Tienda con combo de  nevera para 4 personas", 3, 250.0, 750.0],
      [
        6002,
        "Tienda gigante para cama de camión con combo de nevera",
        5,
        670.0,
        3350.0,
      ],
    ];

    const table1 = sheet1.tables.add("A3:E3", true);
    table1.name = "VentasTiendas";
    table1.getHeaderRowRange().values = [headers1];
    table1.style = "TableStyleMedium7";
    table1.rows.add(undefined, data1);

    // Green header styling
    const headerRange1 = table1.getHeaderRowRange();
    headerRange1.format.fill.color = "#375623";
    headerRange1.format.font.color = "#FFFFFF";
    headerRange1.format.font.bold = true;

    // Currency format for Precio and Total
    const lastRow1 = data1.length + 3;
    sheet1.getRange(`D4:E${lastRow1}`).numberFormat = Array(data1.length).fill(
      ["$#,##0.00", "$#,##0.00"],
    );

    // Column widths
    sheet1.getRange("A:A").format.columnWidth = 70;
    sheet1.getRange("B:B").format.columnWidth = 300;
    sheet1.getRange("C:C").format.columnWidth = 80;
    sheet1.getRange("D:D").format.columnWidth = 70;
    sheet1.getRange("E:E").format.columnWidth = 90;

    // Row 13: hyperlink placeholder text (student adds hyperlink in Task 2)
    sheet1.getRange("B13").values = [
      ["Haga clic para obtener precios de hielera\u2020"],
    ];
    sheet1.getRange("B13").format.font.color = "#0563C1";
    sheet1.getRange("B13").format.font.underline = "Single";

    // Chart: Inventario (only first 3 tent types — B3:C6)
    const chart = sheet1.charts.add(
      Excel.ChartType.columnClustered,
      sheet1.getRange("B3:C6"),
      Excel.ChartSeriesBy.columns,
    );
    chart.title.text = "Inventario";
    chart.title.format.font.color = "#FFFFFF";
    chart.title.format.font.size = 14;
    chart.format.fill.setSolidColor("#404040");
    chart.plotArea.format.fill.setSolidColor("#404040");
    chart.legend.visible = false;
    chart.setPosition("G3");
    chart.height = 300;
    chart.width = 450;

    // Green bars
    const series0 = chart.series.getItemAt(0);
    series0.format.fill.setSolidColor("#70AD47");

    await context.sync();

    // ─── SHEET 2: Pesca ───
    const sheet2 = context.workbook.worksheets.add("Pesca");

    // Title (NOT merged — Task 1 asks student to merge A1:E1)
    sheet2.getRange("A1").values = [
      ["Venta de campamento - Equipo de pesca"],
    ];
    sheet2.getRange("A1").format.font.name = "Cambria";
    sheet2.getRange("A1").format.font.size = 28;
    sheet2.getRange("A1").format.font.color = "#375623";
    sheet2.getRange("A1").format.font.bold = false;
    sheet2.getRange("A1").format.horizontalAlignment = "Left";
    sheet2.getRange("A1").format.verticalAlignment = "Center";
    sheet2.getRange("1:1").format.rowHeight = 50;

    // Table
    const headers2 = [
      "Artículo #",
      "Descripción",
      "Inventario",
      "Precio",
      "Total",
    ];

    const data2: (string | number)[][] = [
      [1003, "Hielera grande", 20, 109.99, 2199.8],
      [9101, "Línea de pesca de 100 pies.", 2, 5.99, 11.98],
      [9102, "Línea de pesca 200 pies.", 22, 7.99, 175.78],
      [9103, "Paquete de caña y carrete", 15, 42.99, 644.85],
      [9104, "Paquete de pesca con mosca", 8, 69.99, 559.92],
      [9105, "DIY Fly Kit", 13, 54.99, 714.87],
      [
        9106,
        "Kit de limpieza de pescado Mantén la frescura con hielera",
        4,
        129.99,
        519.96,
      ],
      [9107, "Caja de aparejos con cebo de limo", 21, 139.99, 2939.79],
      [9108, "Botas altas de goma , OSFA", 3, 165.99, 497.97],
      [9109, "Portacaña", 4, 22.0, 88.0],
      [
        9110,
        "Portacañas con almacenamiento de pescado extraíble",
        10,
        60.0,
        600.0,
      ],
    ];

    const table2 = sheet2.tables.add("A3:E3", true);
    table2.name = "EquipoPesca";
    table2.getHeaderRowRange().values = [headers2];
    table2.style = "TableStyleMedium7";
    table2.rows.add(undefined, data2);

    // Green header styling
    const headerRange2 = table2.getHeaderRowRange();
    headerRange2.format.fill.color = "#375623";
    headerRange2.format.font.color = "#FFFFFF";
    headerRange2.format.font.bold = true;

    // Currency format for Precio and Total
    const lastRow2 = data2.length + 3;
    sheet2.getRange(`D4:E${lastRow2}`).numberFormat = Array(data2.length).fill(
      ["$#,##0.00", "$#,##0.00"],
    );

    // Column widths
    sheet2.getRange("A:A").format.columnWidth = 70;
    sheet2.getRange("B:B").format.columnWidth = 300;
    sheet2.getRange("C:C").format.columnWidth = 80;
    sheet2.getRange("D:D").format.columnWidth = 70;
    sheet2.getRange("E:E").format.columnWidth = 90;

    sheet1.activate();
    sheet1.getRange("A1").select();

    await context.sync();
  });
}
